<template>
  <div class="px-8 py-6" style="height:100dvh; width:100%;overflow-y: auto;">
    <div class="dashboard-heading">
      <h3>
        {{ `대시보드 - ` + constructionName.constructionName }}
      </h3>
      <p v-if="isJhProject" class="aggregation-notice" role="note">
        <v-icon class="aggregation-notice__icon" size="16">
          mdi-information-outline
        </v-icon>
        <strong>
          {{ isNewArea ? "월별 집계 기준" : "월별 집계 변경 기준" }}
        </strong>
        <template v-if="isNewArea">
          <span class="aggregation-notice__period">
            전월 26일부터 당월 25일까지 집계
          </span>
        </template>
        <template v-else>
          <span class="aggregation-notice__period">
            2026년 8월까지 매월 1일 ~ 말일
          </span>
          <span class="aggregation-notice__period">
            2026년 9월은 9월 1일 ~ 9월 25일
          </span>
          <span class="aggregation-notice__period">
            2026년 10월부터 전월 26일 ~ 당월 25일
          </span>
        </template>
      </p>
    </div>
    <v-spacer v-resize="updateWindowHeight" />
    <div class="align-center d-flex pt-5">
      <div v-if="tabs == 'total'">
        <span class="basedate-text mr-3">기준일자</span>
        <input
          readonly
          v-model="showDate"
          @click="startDateOpenMethod()"
          class="cursor-pointer border-b8b8b8 back-white color-6c6c6c width170-height36 mr-3 rounded-md"
        />
        <DatePicker
          @date="startDateMethod"
          :statement="'start'"
          :sendDialog="startDateOpen"
          @datefunction="startDateFunction()"
        />
      </div>
      <div v-if="tabs == 'day'">
        <span class="basedate-text mr-3">기준일자</span>
        <input
          readonly
          v-model="dayStartDate"
          @click="startDateOpenMethod()"
          class="cursor-pointer border-b8b8b8 back-white color-6c6c6c width170-height36 mr-3 rounded-md"
        />~
        <input
          readonly
          v-model="dayEndDate"
          @click="finishDateOpenMethod()"
          class="cursor-pointer border-b8b8b8 back-white color-6c6c6c width170-height36 mr-3 rounded-md"
        />
        <DatePicker
          @date="startDateMethod"
          :statement="'start'"
          :sendDialog="startDateOpen"
          @datefunction="startDateFunction()"
        />
        <DatePicker
          @date="finishDateMethod"
          :statement="'finish'"
          :sendDialog="finishDateOpen"
          @datefunction="finishDateFunction()"
        />
      </div>
      <v-btn
        dark
        color="#3F557D"
        width="78"
        height="36"
        v-if="tabs != 'month'"
        @click="searchListData"
      >
        조회</v-btn
      >
      <v-spacer />
      <div class="d-flex align-center justify-center tabs-wapper">
        <div
          v-for="tab in tabList"
          :key="tab.value"
          class="tab align-center justify-center d-flex"
          @click="changeStatus(tab.value)"
          :class="tabs == tab.value ? 'active-on' : ''"
        >
          {{ tab.text }}
        </div>
      </div>

      <!-- <v-btn
        class="border-btn align-center justify-center d-flex ml-3"
        width="120"
        height="36"
        @click="downFile"
      >
        <img src="/static/btn/down.png" class="mr-1" />
        <span class="border-text">내려받기</span>
      </v-btn> -->
    </div>
    <div class="ma-0 pa-0 mt-5">
      <v-simple-table fixed-header dense style="width:100%">
        <thead>
          <tr>
            <th rowspan="2" class="back-ff4040 color-white first-child1">
              <div style="margin:auto" class="width-130">
                미확인물량
              </div>
            </th>
            <th
              v-for="(material, index) in materialList"
              :key="index"
              :class="['back-ff4040 color-white justify-center aling-center']"
              style="height:40px !important;min-width:120px"
            >
              <div>
                {{ material.rebar_name }}
              </div>
            </th>
            <th class="back-ff4040 color-white last-child2 right-th-width">
              <div class="d-flex justify-center align-center">
                미확인합계
              </div>
            </th>
            <th class="back-ff4040 color-white last-child1 right-th-width">
              <div class="d-flex justify-center align-center">
                총반입량 <br />
                (미확인 + 확인)
              </div>
            </th>
          </tr>
          <tr>
            <td
              v-for="(material, index) in totalAllList"
              :key="index"
              style="min-width:120px"
              :class="[
                index !== totalAllList.length - 1 ? 'border-right-aaaaaa' : '',
                'border-bottom-aaaaaa text-right pr-2',
              ]"
            >
              {{
                material.total == 0 || !material.total
                  ? "0"
                  : material.total.toFixed(3)
              }}
            </td>
            <td
              class="last-child2 back-fff4ea border-left-aaaaaa border-bottom-aaaaaa text-right pr-2"
            >
              {{ sumList(totalAllList) }}
            </td>
            <td
              class="last-child1 back-fff4ea border-right-aaaaaa border-left-aaaaaa border-bottom-aaaaaa text-right pr-2"
            >
              {{ Number(monthTotalSum ? monthTotalSum : 0).toFixed(3) }}
            </td>
          </tr>
        </thead>
      </v-simple-table>
    </div>
    <div class="ma-0 pa-0 mt-5" v-if="tabs == 'total'">
      <v-simple-table
        style="width:100%"
        class=" back-fbfbfb col-sticky"
        fixed-header
        dense
        :maxHeight="windowInnerHeight - 48 - 280"
      >
        <thead>
          <tr>
            <th
              class="color-white back-8ca9dd border-right-white first-child1 "
            >
              <div style="margin: auto;" class="width-130">
                강종
              </div>
            </th>
            <th
              v-for="(material, index) in materialList"
              :key="index"
              :class="['color-white back-8ca9dd border-right-white']"
              style="min-width:120px"
            >
              <div>
                {{ material.rebar_name }}
              </div>
            </th>
            <th
              class="color-white back-8ca9dd last-child1 border-left-white"
              style="width:220px"
            >
              <div style="width:220px">
                합계
              </div>
            </th>
          </tr>
        </thead>
        <tbody v-if="statisticsList[0]">
          <tr>
            <td
              class="back-f5f5f5 border-right-aaaaaa border-left-aaaaaa border-bottom-aaaaaa first-child1"
            >
              <div>
                수량(t)
              </div>
            </td>
            <td
              v-for="(material, index) in statisticsList[0].totalList"
              :key="index"
              :class="[
                index !== statisticsList[0].totalList.length - 1
                  ? 'border-right-aaaaaa'
                  : '',
                'border-bottom-aaaaaa',
              ]"
            >
              <div class="text-right pr-2">
                {{
                  material.total == 0 || !material.total
                    ? "0"
                    : material.total.toFixed(3)
                }}
              </div>
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa last-child1 border-left-aaaaaa"
            >
              <div class="text-right pr-2">
                {{ sumList(statisticsList[0].totalList) }}
              </div>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <YearQuantityTable
        ref="yearQuantityTable"
        :monthList="monthList"
        :storeMonthList="storeMonthList"
        :totalTon="totalTon"
        :quantityPlanTotalTon="quantityPlanTotalTon"
        :activeMonths="storeMonthLabels"
        :monthColumnWidth="monthColumnWidth"
        @onUpdateFilter="onUpdateFilter"
        @onUpdateTableWidth="onUpdateTableWidth"
        @onHorizontalScroll="syncChartScroll"
      />

      <div class="d-flex pb-6">
        <div class="monthly-chart-label font-weight-bold mt-8 font-14">
          월별 반입률<br />
          (발주계획 수량 기준)
        </div>
        <div
          ref="chartScroll"
          :class="[
            'monthly-chart-scroll mt-4',
            {
              'monthly-chart-scroll--empty':
                !monthLabels || monthLabels.length === 0,
            },
          ]"
          @scroll="syncTableScroll"
        >
          <Chart
            height="26dvh"
            barRef="lineChart-activity"
            borderColor="#589EF6"
            backgroundColor="#589EF6"
            datasetLabel="월별 반입량 누계"
            :quantityPlanTotalTon="quantityPlanTotalTon"
            :labels="monthLabels"
            :dataList="monthDatas"
            :pointGap="chartPointGap"
          />
        </div>
      </div>
    </div>
    <div class="ma-0 pa-0 " v-if="tabs == 'month'">
      <v-simple-table
        class=" back-fbfbfb mt-5"
        fixed-header
        dense
        style=" width: 100%"
        :height="windowInnerHeight - 48 - 280"
      >
        <thead>
          <tr>
            <th
              class="color-white back-8ca9dd border-right-white first-child1"
              style="z-index: 19 !important;"
            >
              <div class="width-130" style="margin: auto;">월별집계</div>
            </th>
            <th
              v-for="(material, index) in materialList"
              :key="index"
              :class="[
                index !== materialList.length - 1 ? 'border-right-white' : '',
                'color-white back-8ca9dd',
              ]"
              style="min-width:120px"
            >
              <div>{{ material.rebar_name }}</div>
            </th>
            <th
              class="color-white back-8ca9dd last-child2 border-left-white back-fff4ea right-th-width"
              style="z-index: 19 !important;"
            >
              <div class="right-th-width" style="margin: auto;">
                합계
              </div>
            </th>
            <th
              class="color-white back-8ca9dd last-child1 border-left-white back-fff4ea right-th-width"
              style="z-index: 19 !important;"
            >
              <div class="right-th-width" style="margin: auto;">
                누계
              </div>
            </th>
          </tr>
          <tr>
            <th
              class="back-f5f5f5 border-right-aaaaaa border-left-aaaaaa border-bottom-aaaaaa first-child1 "
              style="z-index: 19 !important;"
            >
              합계
            </th>

            <th
              v-for="(material, index) in materialList"
              :key="index"
              :class="[
                index !== materialList.length - 1 ? 'border-right-aaaaaa' : '',
                'border-bottom-aaaaaa text-right pr-2',
              ]"
            >
              {{ rebarTotal(statisticsList, index, material) }}
            </th>
            <th
              class="border-bottom-aaaaaa last-child2 border-left-aaaaaa back-fff4ea text-right pr-2"
              style="z-index: 19 !important;"
            >
              {{ totalSumList(statisticsList) }}
            </th>
            <th
              class="border-right-aaaaaa border-bottom-aaaaaa last-child1 border-left-aaaaaa back-fff4ea text-right pr-2"
              style="z-index: 19 !important;"
            >
              {{ totalSumList(statisticsList) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(month, index) in statisticsList"
            :key="index"
            :class="[month.closeYn === 'Y' ? 'done-tr' : '']"
          >
            <td
              :class="[
                viewerRole ? 'justify-center' : '',
                'border-right-aaaaaa border-left-aaaaaa border-bottom-aaaaaa d-flex align-center first-child1',
              ]"
              :style="{
                backgroundColor: month.closeYn === 'Y' ? '#fff4f4' : '#f5f5f5',
              }"
            >
              <button
                type="button"
                style="width: 48px;"
                @click="onDoneMonthBtn(month.selectDate, month.closeYn)"
                v-if="!viewerRole"
              >
                <v-icon v-if="month.closeYn === 'Y'" size="14" color="#222222">
                  mdi-lock
                </v-icon>
                <div v-if="month.closeYn === 'N'" class="done-text">
                  마감
                </div>
              </button>
              {{ month.selectDate }}
            </td>
            <td
              v-for="i in materialList.length"
              :key="i"
              :class="[
                i !== materialList.length ? 'border-right-aaaaaa' : '',
                'border-bottom-aaaaaa text-right pr-2',
              ]"
            >
              {{
                month.totalList[i - 1]
                  ? month.totalList[i - 1].total == 0
                    ? "0"
                    : mathRound(month.totalList[i - 1].total).toFixed(3)
                  : "0"
              }}
            </td>
            <td
              class="border-bottom-aaaaaa last-child2 border-left-aaaaaa back-fff4ea text-right pr-2"
            >
              {{ sumList(month.totalList) }}
            </td>

            <td
              class="border-right-aaaaaa border-bottom-aaaaaa last-child1 border-left-aaaaaa back-fff4ea text-right pr-2"
            >
              {{ mathRound(sumList3[index]).toFixed(3) }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
    <div class="ma-0 pa-0 mt-5">
      <v-simple-table
        v-if="tabs == 'day'"
        style="width:100%"
        fixed-header
        :height="windowInnerHeight - 48 - 280"
        dense
      >
        <thead>
          <tr>
            <th
              class="color-white back-8ca9dd border-right-white first-child1"
              style="z-index: 20 !important; "
            >
              <div class="width-130" style="margin: auto;">날짜</div>
            </th>
            <th
              v-for="(material, index) in materialList"
              :key="index"
              :class="[
                index !== materialList.length - 1 ? 'border-right-white' : '',
                'color-white back-8ca9dd',
              ]"
              style="min-width:120px"
            >
              <div>{{ material.rebar_name }}</div>
            </th>
            <th
              class="last-child2 color-white back-8ca9dd border-left-white right-th-width"
              style="z-index: 20 !important; "
            >
              <div class="right-th-width" style="margin: auto;">합계</div>
            </th>
            <th
              class="last-child1 color-white back-8ca9dd  border-left-white right-th-width"
              style="z-index: 20 !important; "
            >
              <div class="right-th-width" style="margin: auto;">누계</div>
            </th>
          </tr>
          <tr>
            <th
              class="first-child1 border-left-aaaaaa border-right-aaaaaa border-bottom-aaaaaa back-f5f5f5"
              style="z-index: 20 !important; "
            >
              합계
            </th>
            <th
              v-for="(material, index) in statisSumList"
              :key="index"
              :class="[
                index !== statisSumList.length - 1 ? 'border-right-aaaaaa' : '',
                'border-bottom-aaaaaa',
              ]"
              style="min-width: 120px;"
            >
              <div class="text-right pr-2">
                {{ mathRound(material).toFixed(3) }}
              </div>
            </th>
            <th
              class="last-child2 border-bottom-aaaaaa border-left-aaaaaa"
              style="z-index: 20 !important; "
            >
              <div class=" text-right pr-2 ">
                {{ sumList1(statisSumList) }}
              </div>
            </th>
            <th
              class="last-child1 border-right-aaaaaa border-bottom-aaaaaa border-left-aaaaaa"
              style="z-index: 20 !important; "
            >
              <div class=" text-right pr-2">
                {{ sumList1(statisSumList) }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(statis, index) of statisticsList"
            :key="index"
            :class="[statis.closeYn === 'Y' ? 'done-tr' : '']"
          >
            <td
              class="first-child1 border-left-aaaaaa border-right-aaaaaa border-bottom-aaaaaa"
              :style="{
                backgroundColor: statis.closeYn === 'Y' ? '#fff4f4' : '#f5f5f5',
              }"
            >
              {{ statis.selectDate }}
            </td>

            <td
              v-for="index in materialList.length"
              :key="index"
              :class="[
                index !== materialList.length ? 'border-right-aaaaaa' : '',
                'border-bottom-aaaaaa',
              ]"
              style="min-width: 120px;"
            >
              <div class=" text-right pr-2 ">
                {{
                  statis.totalList[index - 1]
                    ? statis.totalList[index - 1].total == 0
                      ? "0"
                      : mathRound(statis.totalList[index - 1].total).toFixed(3)
                    : "0"
                }}
              </div>
            </td>
            <td
              class="last-child2 border-bottom-aaaaaa back-fff4ea border-left-aaaaaa"
            >
              <div class=" text-right pr-2">
                {{ sumList(statis.totalList) }}
              </div>
            </td>
            <td
              class="last-child1 border-right-aaaaaa border-bottom-aaaaaa border-left-aaaaaa back-fff4ea"
            >
              <div class=" text-right pr-2">
                {{ mathRound(sumList3[index]).toFixed(3) }}
              </div>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import OrderInvoiceService from "@/api/OrderInvoiceService.js";
import DatePicker from "@/components/DatePicker";
import DatePickerMixin from "@/mixin/DatePicker";
import Commonality from "@/mixin/Commonality";
import FileService from "@/api/FileService.js";
import fileDownload from "@/assets/js/file-download.js";
import Chart from "@/components/dashBoard/Chart.vue";
import YearQuantityTable from "@/components/dashBoard/YearQuantityTable.vue";
import AppAPI from "@/api/AppSettingService";

export default {
  mixins: [DatePickerMixin, Commonality],
  components: {
    DatePicker,
    Chart,
    YearQuantityTable,
  },
  data: () => ({
    tabs: "total",
    tabList: [
      { text: "전체보기", value: "total" },
      { text: "월별보기", value: "month" },
      { text: "일별보기", value: "day" },
    ],
    monthTotalText: "총반입량 <br> (미확인 + 확인)",
    totalAllList: [],
    statisticsList: [],
    cumulativeList: [],
    statisSumList: [],
    sumList3: [],
    monthTotalSum: 0,
    windowInnerHeight: 0,
    monthList: [],
    totalTon: 0,
    quantityPlanTotalTon: 0,
    monthLabels: [],
    monthDatas: [],
    storeMonthList: null,
    storeMonthLabels: null,
    storeMonthDatas: null,
    yearMonthList: null,
    tableWidth: null,
  }),
  computed: {
    showDate() {
      const date = this.startDate
        ? this.startDate
        : this.$moment(new Date()).format("YYYY-MM-DD");
      return this.$moment(date).format("YYYY년 MM월 DD일");
    },
    dayStartDate() {
      const date = this.startDate ? this.startDate : "2020-01-01";
      return this.$moment(date).format("YYYY년 MM월 DD일");
    },
    dayEndDate() {
      const date = this.finishDate
        ? this.finishDate
        : this.$moment(new Date()).format("YYYY-MM-DD");
      return this.$moment(date).format("YYYY년 MM월 DD일");
    },
    viewerRole() {
      return this.$store.getters.getUserList.roleType === "뷰어";
    },
    /** 중흥 운영, 중흥 개발 */
    isJhProject() {
      return (
        this.$store.getters.getAppsetting?.projectName === "jh" ||
        this.$store.getters.getAppsetting?.projectName === "dev"
      );
    },
    firstAggregationMonth() {
      const firstYearGroup =
        Array.isArray(this.monthList) && this.monthList.length
          ? this.monthList[0]
          : null;
      const firstMonth =
        firstYearGroup &&
        Array.isArray(firstYearGroup.monthList) &&
        firstYearGroup.monthList.length
          ? firstYearGroup.monthList[0].month
          : null;

      if (!firstYearGroup || !firstMonth) return "";

      return `${firstYearGroup.year}-${String(firstMonth).padStart(2, "0")}`;
    },
    /** 첫 집계월이 2026년 10월 이후인 신규 현장 여부 */
    isNewArea() {
      if (!this.firstAggregationMonth) return true;

      const NEW_AREA_START_DATE = "2026-10-01";
      return this.$moment(`${this.firstAggregationMonth}-01`).isSameOrAfter(
        NEW_AREA_START_DATE,
        "month",
      );
    },
    monthColumnWidth() {
      if (!this.tableWidth) return 56;

      return Math.ceil((this.tableWidth - 224) / 24);
    },
    chartPointGap() {
      if (!this.tableWidth) return 56;

      return Math.ceil((this.tableWidth - 224 - 10) / 24);
    },
  },
  async created() {
    this.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.selectListData(this.tabs);
    await this.getMonthTableList();
  },
  methods: {
    async searchListData() {
      if (this.tabs === "total") {
        await this.getMonthTableList();
      }

      await this.selectListData(this.tabs);
    },
    syncChartScroll(scrollLeft) {
      if (
        this.$refs.chartScroll &&
        this.$refs.chartScroll.scrollLeft !== scrollLeft
      ) {
        this.$refs.chartScroll.scrollLeft = scrollLeft;
      }
    },
    syncTableScroll(event) {
      this.$refs.yearQuantityTable?.setScrollLeft(event.target.scrollLeft);
    },
    /** 동적 테이블 너비 값 받는 함수 */
    onUpdateTableWidth(tableWidth) {
      this.tableWidth = tableWidth;
    },
    /** 월별 마감 핸들러 */
    async onDoneMonthBtn(monthDate, curCloseYn) {
      const closeYn = curCloseYn === "Y" ? "N" : "Y";
      try {
        await AppAPI.closeMonth(monthDate, closeYn, this.constructionId);
        await this.selectListData(this.tabs);
      } catch (e) {
        console.error(e);
      }
    },
    /** 윈도우 동적높이 가져오는 함수 */
    updateWindowHeight() {
      if (typeof window !== "undefined") {
        this.windowInnerHeight = window.innerHeight;
      }
    },
    /** 월별 반입수량 조회 함수
     * @param filteredMonthList 필터될 yearMonthList 목록 예) ['2024-01', '2024-03']
     */
    async getMonthTableList(filteredMonthList) {
      const isInitialLoad = !filteredMonthList;

      const payload = {
        constructionId: this.constructionId,
        selectDate: this.$moment(this.startDate || new Date()).format(
          "YYYY-MM-DD",
        ),
        yearMonthList: isInitialLoad ? null : filteredMonthList,
      };

      try {
        const { data } = await OrderInvoiceService.getMonthList(payload);
        // 1. 테이블 세팅
        this.monthList = data?.monthList;
        this.totalTon = data?.totalTon;
        this.quantityPlanTotalTon = data?.quantityPlanTotalTon;

        const labels = data?.monthList.flatMap(({ year, monthList }) =>
          monthList.map(({ month }) => `${year}.${month}`),
        );
        // 1. 총누계 대비 월반입량누계
        // const percents = data?.monthList.flatMap(({ monthList }) =>
        //   monthList.map(({ montlyTon }) =>
        //     ((montlyTon / data?.totalTon) * 100)?.toFixed(2)
        //   )
        // );
        // 2. 실행수량 대비 월반입량누계
        const 월반입량누계 = data?.monthList.flatMap(({ monthList }) =>
          monthList.map(({ totalTon }) => totalTon),
        );

        this.monthLabels = labels;
        this.monthDatas = 월반입량누계;
        this.storeMonthDatas = 월반입량누계;

        // [필터 미적용 시] 필터 초기 데이터 저장 (필터 초기값으로 복원용)
        if (isInitialLoad) {
          this.storeMonthList = data?.monthList;
          this.storeMonthLabels = labels;
        }

        // 2. 차트 세팅
      } catch (e) {
        console.error(e);
      }
    },
    /** 실행수량 필터 핸들러 */
    async onUpdateFilter(filter) {
      /** 백엔드측 필터 */
      await this.getMonthTableList(filter);

      /** 프론트측 필터 */
      // this.filteredTable(filter); // 테이블 업데이트
      // this.filteredChart(filter); // 차트 업데이트
    },
    filteredTable(filter) {
      const filterSet = new Set(filter);

      const filteredMonthList = this.storeMonthList
        .map(({ year, monthList }) => {
          const filteredMonths = monthList.filter(({ month }) => {
            const key = `${year}-${month}`;
            return filterSet.has(key);
          });

          return filteredMonths.length
            ? { year, monthList: filteredMonths }
            : null;
        })
        .filter(Boolean); // null 제거

      this.monthList = filteredMonthList;
    },
    filteredChart(filter) {
      const convertedLabel = this.storeMonthLabels.map((label) =>
        label.replace(".", "-"),
      );

      // 2. filter 기준으로 매칭되는 인덱스만 추출
      const filtered = convertedLabel
        .map((label, idx) => {
          if (filter.includes(label)) {
            return {
              label: this.storeMonthLabels[idx],
              value: this.storeMonthDatas[idx],
            };
          }
          return null;
        })
        .filter(Boolean);
      this.monthLabels = filtered.map((f) => f.label);
      this.monthDatas = filtered.map((f) => f.value);
    },
    /**
     *
     * @param {Text} payload status상태
     */
    async selectListData(payload) {
      let data = {
        constructionId: this.constructionId,
        type: payload == "total" ? "A" : payload == "day" ? "D" : "M",
      };

      if (payload === "total") {
        data.selectDate = this.startDate;
      } else if (payload === "day") {
        data.startDate = this.startDate;
        data.endDate = this.finishDate
          ? this.finishDate
          : this.$moment(new Date()).format("YYYY-MM-DD");
      }
      let res = await OrderInvoiceService.statisticsList(data);
      this.totalAllList = res.data.statisticsNotCompleteList[0].totalList;
      this.monthTotalSum = res.data.statisticsNotCompleteList[0].total;
      this.statisticsList = res.data.statisticsList;
      let sumList = [];
      let sumList1 = [];
      for (let j = 0; j < this.materialList.length; j++) {
        sumList[j] = 0;
      }
      let sum = 0;
      for (let i of res.data.statisticsList) {
        for (let j = 0; j < i.totalList.length; j++) {
          let tempValue = i.totalList[j].total;
          sumList[j] += tempValue;
          sum += tempValue;
        }
        sumList1.push(sum);
      }
      this.sumList3 = sumList1;
      this.statisSumList = sumList;
      this.tabs = payload;
    },

    /**
     *
     * @param {*} status 상태값
     */
    async changeStatus(status) {
      if (status == "day") {
        this.startDate = "2020-01-01";
      }
      if (status == "total") {
        this.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
        await this.getMonthTableList();
      }
      await this.selectListData(status);
    },
    sumList1(list) {
      let sum = 0;
      for (let i of list) {
        sum += i;
      }
      return (Math.round(sum * 1000) / 1000).toFixed(3);
    },
    sumList(list) {
      let sum = 0;
      for (let i of list) {
        sum += i.total;
      }
      return (Math.round(sum * 1000) / 1000).toFixed(3);
    },
    rebarTotal(list, index, material) {
      let sum = 0;
      for (let i of list) {
        for (let j of i.totalList) {
          if (j.rebarName == material.rebar_name) {
            sum += Number(j.total);
          }
        }
      }
      return (Math.round(sum * 1000) / 1000).toFixed(3);
    },
    totalSumList(list) {
      let sum = 0;
      for (let i of list) {
        for (let j of i.totalList) {
          sum += Number(j.total);
        }
      }
      return (Math.round(sum * 1000) / 1000).toFixed(3);
    },
    /** (구) 내려받기 */
    async downFile() {
      let data = {
        constructionId: this.constructionId,
      };
      if (this.tabs == "total") {
        data.selectDate = this.startDate;
      } else if (this.tabs == "day") {
        data.startDate = this.startDate;
        data.endDate = this.finishDate
          ? this.finishDate
          : this.$moment(new Date()).format("YYYY-MM-DD");
      }
      let res = await FileService.statisticsDown(data);
      fileDownload(
        res.data,
        `${this.constructionName.constructionName} 통계.xlsx`,
      );
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard-heading {
  display: flex;
  align-items: center;
  gap: 22px;
  overflow: hidden;

  h3 {
    flex: 0 0 auto;
  }
}
.aggregation-notice {
  display: flex;
  align-items: center;
  overflow: hidden;
  margin: 0 0 0 auto;
  border: 1px solid rgba(88, 158, 246, 0.35);
  border-radius: 5px;
  background: rgba(88, 158, 246, 0.07);
  box-shadow: 0 1px 2px rgba(88, 158, 246, 0.08);
  color: #48617f;
  font-family: "Noto Sans KR", sans-serif;
  font-size: 12px;
  line-height: 28px;
  text-overflow: ellipsis;
  white-space: nowrap;

  .aggregation-notice__icon {
    align-self: stretch;
    padding-left: 10px;
    background: rgba(88, 158, 246, 0.16);
    color: #4173b5;
  }

  strong {
    align-self: stretch;
    flex: 0 0 auto;
    padding: 0 11px 0 7px;
    border-right: 1px solid rgba(88, 158, 246, 0.25);
    background: rgba(88, 158, 246, 0.16);
    color: #4173b5;
    font-weight: 700;
  }

  .aggregation-notice__period {
    flex: 0 0 auto;
    padding: 0 11px;
    font-weight: 500;

    & + .aggregation-notice__period {
      border-left: 1px solid rgba(88, 158, 246, 0.2);
    }
  }
}
.monthly-chart-scroll {
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  scrollbar-color: #c8cdd2 transparent;
  scrollbar-width: thin;
}
.monthly-chart-scroll--empty {
  overflow-x: hidden;
}
.monthly-chart-label {
  flex: 0 0 120px;
  white-space: nowrap;
}
.monthly-chart-scroll::-webkit-scrollbar {
  height: 8px;
}
.monthly-chart-scroll::-webkit-scrollbar-track {
  border: 0;
  background: transparent;
  box-shadow: none;
}
.monthly-chart-scroll::-webkit-scrollbar-thumb {
  border: 2px solid transparent;
  border-radius: 4px;
  background: #c8cdd2;
  background-clip: content-box;
}
.width-min-130 {
  min-width: 130px;
}
.back-fff4ea {
  background: #fff4ea;
}
.width-130 {
  width: 130px;
}
.right-th-width {
  width: 110px !important;
  min-width: 110px !important;
  max-width: 110px !important;
}
.back-ff4040 {
  background: #ff4040 !important;
}
.last-child2 {
  position: sticky;
  right: 110px;
  z-index: 15 !important;
}
.last-child1 {
  position: sticky;
  right: 0;
  z-index: 15 !important;
}
.first-child1 {
  position: sticky;
  left: 0;
  z-index: 15 !important;
}
.color-6c6c6c {
  color: #6c6c6c;
}
.width170-height36 {
  width: 170px;
  height: 36px;
}
.basedate-text {
  font-family: "Noto Sans KR";
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
}
.active-on {
  background: white !important;
  font-weight: 700 !important;
}
.tabs-wapper {
  background: #eeeeee;
  border-radius: 5px;
}
.tab {
  width: 80px;
  height: 36px;
  text-align: center;
  border: thin solid #e5e5e5;
  background: #eeeeee;
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.rounded-md {
  border-radius: 5px;
}
.border-b8b8b8 {
  border: 1px solid #b8b8b8;
}
.bg-ecf3f9 {
  background-color: #ecf3f9 !important;
}
.done-text {
  color: #8ca9dd;
  text-align: center;
  font-family: "Noto Sans KR";
  font-size: 12px;
  line-height: 10px;
  text-decoration-line: underline;
  text-underline-position: from-font;
}
.done-tr {
  > td {
    // mix-blend-mode: multiply;
    // background-color: rgba(255, 64, 64, 0.06);
    background-color: #fff4f4;
  }
}
.font-14 {
  font-size: 14px;
}
</style>
